/**
 * DEV-1018. i18n аналитики презентаций (Reports-таб + таб карточки агента).
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей (reports.*,
 * agentsRegistry.*), чтобы не раздувать монолитные ru/en/vn.
 */
export const presentationsAnalyticsMessages = {
  ru: {
    reports: {
      tabs: { presentations: 'Презентации' },
      presentations: {
        subtitle: 'Создание и просмотры презентаций агентов',
        sinceNote: 'Статистика собирается с июля 2026',
        kpiCreated: 'Создано',
        kpiSent: 'Отправлено',
        kpiViews: 'Просмотры',
        kpiConversion: 'Открыто отправок',
        openedOf: '{opened} из {sent}',
        chartHint: 'По дням периода, сутки по Вьетнаму',
        // DEV-2430: что считается и за какой период.
        hints: {
          created: 'Презентации, созданные агентами за период (включая удалённые позже).',
          sent: 'Адресные отправки клиентам за период.',
          views:
            'Все открытия презентаций за период — и по адресной отправке, и по общей ссылке, с повторами.',
          opened:
            'Доля адресных отправок периода, которые клиент открыл хотя бы раз. Открытия по общей ссылке сюда не входят.',
        },
        chartTitle: 'Динамика по дням',
        tableTitle: 'Активность агентов',
        seriesCreated: 'Создано',
        seriesSent: 'Отправлено',
        seriesViews: 'Просмотры',
        colAgent: 'Агент',
        colCreated: 'Создано',
        colSent: 'Отправлено',
        colViews: 'Просмотры',
        colConversion: 'Открыто отправок',
        empty: 'Пока нет данных',
        emptyDescription:
          'Статистика появится, когда агенты начнут создавать и отправлять презентации.',
      },
    },
    agentsRegistry: {
      tabs2: { presentations: 'Презентации' },
      presentations: {
        topTitle: 'Топ презентаций',
        colTitle: 'Название',
        untitled: 'Без названия',
        deleted: '· удалена',
      },
    },
  },
  en: {
    reports: {
      tabs: { presentations: 'Presentations' },
      presentations: {
        subtitle: 'Agent presentation creation and views',
        sinceNote: 'Statistics collected since July 2026',
        kpiCreated: 'Created',
        kpiSent: 'Sent',
        kpiViews: 'Views',
        kpiConversion: 'Shares opened',
        openedOf: '{opened} of {sent}',
        chartHint: 'By day of the period, days in Vietnam time',
        hints: {
          created: 'Presentations agents created in the period (including ones deleted later).',
          sent: 'Personal shares sent to clients in the period.',
          views:
            'All presentation opens in the period — via personal shares and the public link, repeats included.',
          opened:
            'Share of the period’s personal shares the client opened at least once. Opens via the public link are not counted.',
        },
        chartTitle: 'Daily dynamics',
        tableTitle: 'Agent activity',
        seriesCreated: 'Created',
        seriesSent: 'Sent',
        seriesViews: 'Views',
        colAgent: 'Agent',
        colCreated: 'Created',
        colSent: 'Sent',
        colViews: 'Views',
        colConversion: 'Shares opened',
        empty: 'No data yet',
        emptyDescription:
          'Statistics will appear once agents start creating and sending presentations.',
      },
    },
    agentsRegistry: {
      tabs2: { presentations: 'Presentations' },
      presentations: {
        topTitle: 'Top presentations',
        colTitle: 'Title',
        untitled: 'Untitled',
        deleted: '· deleted',
      },
    },
  },
  vn: {
    reports: {
      tabs: { presentations: 'Bài giới thiệu' },
      presentations: {
        subtitle: 'Tạo và lượt xem bài giới thiệu của đại lý',
        sinceNote: 'Thống kê thu thập từ tháng 7 2026',
        kpiCreated: 'Đã tạo',
        kpiSent: 'Đã gửi',
        kpiViews: 'Lượt xem',
        kpiConversion: 'Lượt gửi đã mở',
        openedOf: '{opened} / {sent}',
        chartHint: 'Theo ngày trong kỳ, giờ Việt Nam',
        hints: {
          created: 'Bài giới thiệu đại lý tạo trong kỳ (kể cả bài đã xóa sau đó).',
          sent: 'Lượt gửi riêng cho khách hàng trong kỳ.',
          views:
            'Tất cả lượt mở bài giới thiệu trong kỳ — qua lượt gửi riêng và liên kết chung, tính cả lặp lại.',
          opened:
            'Tỷ lệ lượt gửi riêng trong kỳ mà khách hàng đã mở ít nhất một lần. Không tính lượt mở qua liên kết chung.',
        },
        chartTitle: 'Diễn biến theo ngày',
        tableTitle: 'Hoạt động của đại lý',
        seriesCreated: 'Đã tạo',
        seriesSent: 'Đã gửi',
        seriesViews: 'Lượt xem',
        colAgent: 'Đại lý',
        colCreated: 'Đã tạo',
        colSent: 'Đã gửi',
        colViews: 'Lượt xem',
        colConversion: 'Lượt gửi đã mở',
        empty: 'Chưa có dữ liệu',
        emptyDescription: 'Thống kê sẽ xuất hiện khi đại lý bắt đầu tạo và gửi bài giới thiệu.',
      },
    },
    agentsRegistry: {
      tabs2: { presentations: 'Bài giới thiệu' },
      presentations: {
        topTitle: 'Bài giới thiệu hàng đầu',
        colTitle: 'Tiêu đề',
        untitled: 'Không có tiêu đề',
        deleted: '· đã xóa',
      },
    },
  },
}
